import * as React from "react";
import Avatar, { AvatarSize, AvatarUserInfo } from "./Avatar";
import "./UserCardSmall.scss";

interface UserCardSmallProps {
  userInfo: AvatarUserInfo;
}

export default class UserCardSmall extends React.PureComponent<UserCardSmallProps> {
  render() {
    const { userInfo } = this.props;
    return (
      <div className="user-card-small h-flex align-center">
        <Avatar size={AvatarSize.SMALL} userInfo={userInfo} />
        <span>{userInfo.name}</span>
      </div>
    );
  }
}
